<template>
  <dialog id="modalBagEditor" open>
    <h1>Charge {{ element.uniqueNumber }}</h1>
    <form class="row">

      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="supplierId">Lieferant</label>
        </div>
        <select
            v-model="supplierId"
            @change="supplierChanged"
            class="custom-select custom-select-lg" id="supplierId"
            required>
          <option>Auswählen..</option>
          <option
              v-for="supplier in suppliers"
              :key="supplier.contactId"
              :value="supplier.contactId">{{ supplier.name }}, {{ supplier.city }}
          </option>
        </select>
      </div>

      <div
          v-if="products.length > 1"
          class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="supplierId">Produkt</label>
        </div>
        <select
            v-model="productId"
            @change="productChanged"
            class="custom-select custom-select-lg" id="supplierId"
            required>
          <option>Auswählen..</option>
          <option
              v-for="product in products"
              :key="product.productId"
              :value="product.productId">{{ product.name }}</option>
        </select>
      </div>

      <div
          v-if="!products.length || productId === 1"
          class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="qualityStandard">Standard</label>
        </div>
        <select
            v-model="qualityStandard"
            class="custom-select custom-select-lg" id="qualityStandard"
        >
          <option>Auswählen..</option>
          <option
              v-for="qualityStandard in qualityStandards"
              :key="qualityStandard.id"
              :value="qualityStandard.id">{{ qualityStandard.name }}
          </option>
        </select>
      </div>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="breed">Sorte</label>
        </div>
        <input v-model="breed" class="form-control form-control-lg" id="breed" placeholder="">
      </div>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="regraterId">Aufkäufer</label>
        </div>
        <select
            v-model="regraterId"
            class="custom-select custom-select-lg" id="regraterId">
          <option>Auswählen..</option>
          <option
              v-for="regrater in regraters"
              :key="regrater.contactId"
              :value="regrater.contactId">{{ regrater.name }}
          </option>
        </select>
      </div>
      <div :class="'input-group mb-3'+ (showBatchTime ? ' col-4 w55 pl-0' : '' )">
        <div class="input-group-prepend">
          <label class="input-group-text" for="batchDate">{{ !showBatchTime ? 'Datum' : 'D' }}</label>
        </div>
        <input v-model="batchDate" class="form-control form-control-lg"
               id="batchDate" placeholder="TT.MM.JJJJ" pattern="\d{1,2}.\d{1,2}.\d{4}">
      </div>
      <div v-if="showBatchTime" class="input-group col-4 w45 pr-0 mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="batchTime" style="min-width:auto">Z</label>
        </div>
        <input v-model="batchTime" class="form-control form-control-lg"
               id="batchTime" placeholder="HH:mm">
      </div>
      <div v-if="getIncomingLocationNames" class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="incomingLocationId">Annahme</label>
        </div>
        <select
            v-model="incomingLocationId"
            class="custom-select custom-select-lg" id="incomingLocationId">
          <option>Auswählen..</option>
          <option
              v-for="(location,id) in getIncomingLocationNames"
              :key="id"
              :value="id">{{ location }}
          </option>
        </select>
      </div>
      <!--div v-if="showBatchSampleNumber" class="input-group mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="sampleNumber">Probe Nr</label>
        </div>
        <input v-model="sampleNumber" class="form-control form-control-lg" id="sampleNumber">
      </div-->

    </form>
    <div class="row mt-1 buttons">
      <div class="col-3">
        <button @click="abortDialog" type="reset">Abbrechen</button>
      </div>
      <div class="col-5">
        <button @click="confirmDialog" type="submit">Speichern</button>
      </div>
    </div>
  </dialog>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "PopupBatchEditor",
  data() {
    return {
      supplierId: null,
      productId: null,
      qualityStandard: null,
      breed: null,
      regraterId: null,
      batchDate: null,
      batchTime: null,
      incomingLocationId: null,
      lane: null,
      sampleNumber: null,
    }
  },
  props: {
    element: {
      type: Object,
      required: true
    },
    suppliers: {
      type: Array,
      required: true
    },
    qualityStandards: {
      type: Array,
      required: true
    },
    regraters: {
      type: Array,
      required: true
    }
  },
  created() {
    this.supplierId = this.$props.element.supplierId
    this.productId = this.$props.element.productId
    this.regraterId = this.$props.element.regraterId
    this.qualityStandard = this.$props.element.qualityStandardId
    this.breed = this.$props.element.breed
    if (this.$props.element.batchDateTime) {
      this.batchDate = dayjs(this.$props.element.batchDateTime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('DD.MM.YYYY')
      this.batchTime = dayjs(this.$props.element.batchDateTime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('HH:mm')
    } else if (this.$props.element.batchDate)
      this.batchDate = dayjs(this.$props.element.batchDate).format('DD.MM.YYYY')
    this.incomingLocationId = this.$props.element.incomingLocationId
    this.sampleNumber = this.$props.element.sampleNumber
  },
  computed: {
    showBatchSampleNumber() {
      return this.$store.getters.batchSampleNumber
    },
    getIncomingLocationNames() {
      return this.$store.getters.incomingLocationNames
    },
    showBatchTime() {
      return this.$store.getters.batchTime
    },
    products() {
      return this.$store.state.product
    },
  },
  methods: {
    abortDialog() {
      this.$emit('abortDialog')
    },
    confirmDialog() {
      this.$emit('confirmDialog', {
        id: this.$props.element.batchId,
        supplierId: this.supplierId,
        regraterId: this.regraterId,
        qualityStandard: this.qualityStandard,
        breed: this.breed,
        batchDate: this.batchDate,
        batchTime: this.batchTime,
        incomingLocationId: this.incomingLocationId,
        sampleNumber: this.sampleNumber,
        productId: this.productId,
      })
    }
  }
}
</script>

<style scoped>
dialog {
  z-index: 1000;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  border: 0;
  padding: 20vh 1.5rem 0;
}

dialog .buttons div:first-of-type {
  padding-left: 0;
}

dialog .buttons div:last-child {
  padding-right: 0;
}

.w55 {
  flex: 0 0 55%;
  max-width: 55%;
}
.w45 {
  flex: 0 0 45%;
  max-width: 45%;
}
</style>